export default __webpack_public_path__ + "c88ca52503e82c42723f00c5818737bb.png";